import { render, staticRenderFns } from "./AutomationTags.vue?vue&type=template&id=3e1992b1&scoped=true"
import script from "./AutomationTags.vue?vue&type=script&lang=js"
export * from "./AutomationTags.vue?vue&type=script&lang=js"
import style0 from "./AutomationTags.vue?vue&type=style&index=0&id=3e1992b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1992b1",
  null
  
)

export default component.exports